const isPlatformSubdomain = (subdomain: string) => (
  subdomain === "platform" || subdomain === "eu-platform"
);

export default isPlatformSubdomain;
